import Vue from 'vue'
import VueResource from 'vue-resource'
import { container } from '../services/container'
Vue.use(VueResource)

export class SubscriptionApi {
	constructor () {
		this.url = process.env.VUE_APP_API_URL
		this.access_token = container.get('services.oauth').getToken()
	}

	update (subscription, params) {
		if (!subscription) {
			return Promise.reject(Error('You don\'t have any subscriptions'))
		}

		return Vue.http.put(this.url + '/subscription/' + subscription.token, params, { headers: {
			Authorization: 'Bearer ' + this.access_token
		}})
	}

	getCalendar (token) {
		return Vue.http.get(this.url + '/subscription/' + token + '/calendar', { params: {}, headers: {
			Authorization: 'Bearer ' + this.access_token }
		})
	}

	calendar (subscription, params) {
		if (!subscription) {
			return Promise.reject(Error('You don\'t have any subscriptions'))
		}

		return Vue.http.post(this.url + '/subscription/' + subscription.token + '/calendar', params, {headers: {
			Authorization: 'Bearer ' + this.access_token
		}})
	}

	get (token) { 
    	return Vue.http.get(this.url + '/subscription/' + token, { headers: { 
			Authorization: 'Bearer ' + this.access_token 
    	}}) 
  	} 

	delete (user) {

		return Vue.http.post(this.url + '/me/user/delete', {}, {headers: {
			Authorization: 'Bearer ' + this.access_token
		}})
	}

	suspend (subscription) {
		if (!subscription) {
			return Promise.reject(Error('You don\'t have any subscriptions'))
		}

		if (subscription.status === 'suspended') {
			return Promise.reject(Error('You are already suspended'))
		}

		if (subscription.status === 'started') {
			return Vue.http.post(this.url + '/subscription/' + subscription.token + '/suspend', {}, { headers: {
				Authorization: 'Bearer ' + this.access_token
			}})
		}
	}

	resume (subscription) {
		if (!subscription) {
			return Promise.reject(Error('You don\'t have any subscriptions'))
		}

		if (subscription.status === 'started') {
			return Promise.reject(Error('You are already active'))
		}

		if (subscription.status === 'suspended') {
			return Vue.http.post(this.url + '/subscription/' + subscription.token + '/resume', {}, {headers: {
				Authorization: 'Bearer ' + this.access_token
			}})
		}
	}
}
